export const isFlightOpen = (flight) => {
  if (flight && !!flight.DCSFltStatus) {
    // FIXME // getting occasional error for betterRow.status
    // NOTE // 10 is closed, 5 or '' is open
    let dcsStatus = flight.DCSFltStatus
    if (dcsStatus === '10') {
      return 'closed'
    }
    else {
      return 'open'
    }
  }
  return 'open'
}